<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For my husband Gary and my children Daniel, Leigh-ann, Izabel and Michael. May the Universe provide you with all that you need for a happy and fulfilled life!</p><br/>
<p style="text-align: center;">Much love</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?02b685c0